/* import __COLOCATED_TEMPLATE__ from './plus-tier-banner-market.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Component from '@glimmer/component';
import { Vertical } from '@dashboard/shared-ui/utils/vertical-configs';

/**
  Usage Example:

  <Upsell::PlusTierBannerMarket.js
    @vertical={{this.Vertical.RESTAURANTS}}
    @buttonClass="dummy__button--rst-orange dummy__button--market"
    @buttonClick={{action "popup"}}>

    <:header-image><SqIcon80CircleCircleArrowsPaperCheck/></:header-image>
    <:title>Reopen closed checks</:title>
    <:description>
      Need to reopen a check to make an adjustment, like comping or voiding an accidental item?
    </:description>
    <:button-text>Unlock with Plus</:button-text>
  </Upsell::PlusTierBannerMarket>

  @yields header-image - image to display in the header (on the top)
  @yields title - h3 title copy
  @yields description - description/paragraph copy
  @yields button-text - text to display in footer button
  @yields button-group - optional block to pass through a custom market-button-group

  @param {String} vertical - vertical using this upsell card
  @param {String} buttonClass - CSS class to apply to the button
  @param {Action} buttonAction - action to take when the button is clicked
  @param {String} classNames - CSS class(es) to apply to the market-content-card

*/
export default class PlusTierBannerMarket extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Vertical", Vertical);
  }
}